/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';

import {CircularProgress} from 'material-ui/Progress';
import Button from 'material-ui/Button';
import {LinearProgress} from 'material-ui';

export default class WorkoutButton extends React.PureComponent {
	onPress = () => {
		this.props.onPressButton();
	};

	render() {
		const {progress} = this.props;
		return (
			<div
				style={{
					...(!!progress ? {overflow: 'hidden'} : {}),
					...styles.wrapper,
					...(this.props.wrapperStyles
						? this.props.wrapperStyles
						: {}),
				}}
			>
				{!!this.props.progress && (
					<LinearProgress
						classes={{
							bar1Determinate: 'progress-bar',
						}}
						style={{
							position: 'absolute',
							top: 0,
							bottom: 0,
							left: 0,
							right: 0,
							height: '100%',
							zIndex: 3,
							borderRadius: 30,
							backgroundColor: '#fff'
						}}
						variant='determinate'
						value={this.props.progress}
					/>
				)}
				<Button
					style={{
						borderRadius: 30,
						fontWeight: 900,
						...this.props.style,
						fontFamily: 'Graphik',
					}}
					variant={this.props.variant}
					size={this.props.size}
					color={this.props.color}
					disabled={this.props.loading}
					fullWidth={this.props.fullWidth}
					onClick={() => this.onPress()}
				>
					{this.props.title}
				</Button>
				{this.props.loading && (
					<CircularProgress
						color='primary'
						size={24}
						style={styles.buttonProgress}
					/>
				)}
			</div>
		);
	}
}

const styles = {
	wrapper: {
		position: 'relative',
		borderRadius: '30px',
	},
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12,
	},
};



// WEBPACK FOOTER //
// ./src/components/MyButton.js